module.exports = __webpack_public_path__ + "static/media/upload.79714d50.svg";